<template>
  <div class="banners">
    <div class="wholesale_programme_title">
      <div class="wholesale_programme_title_text" style="width: 780px">
        平台采用独立结算系统，支持多种支付方式，统一结算分账
        <img src="../../assets/img/title3@2x.png" alt="" />
      </div>
      <div class="zhexian"></div>
      <div class="zhexian_text">
        支付流程清晰明确、支付更加便捷高效、信息安全等级保护
      </div>
    </div>
    <div
      class="center"
      style="
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 64px;
      "
    >
      <div class="pay_top_box" v-for="(item, index) in paytext" :key="index">
        <div class="top_box_y">
          <div class="box_y_n">{{ index + 1 }}</div>
        </div>
        <div class="top_box_text">
          <p>{{ item.p }}</p>
          <i>{{ item.i1 }}</i>
          <i>{{ item.i2 }}</i>
        </div>
      </div>
    </div>

    <div class="wholesale_programme_title">
      <div class="wholesale_programme_title_text" style="width: 210px">
        我们的支付方式
        <img src="../../assets/img/title3@2x.png" alt="" />
      </div>
      <div class="zhexian"></div>
    </div>
    <div
      class="center"
      style="
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 60px;
      "
    >
      <div
        :class="{ paymentmethod1: pnumbers == index, paymentmethod: true }"
        v-for="(item, index) in paymentmethods"
        :key="index"
        @mouseover="mouseOver(index)"
        @mouseleave="mouseLeave"
      >
        <div class="paymentmethod_box">
          <img :src="item.url" alt="" />
        </div>
        <p class="paymentmethodp">{{ item.p }}</p>
        <i
          :class="{ paymentmethodi: pnumbers == index, paymentmethodis: true }"
          >{{ item.i }}</i
        >
      </div>
    </div>

    <div class="equipment">
      <div class="wholesale_programme_title" style="padding-top: 61px">
        <div
          class="wholesale_programme_title_text"
          style="width: 120px; color: #ffffff"
        >
          支付设备
          <img src="../../assets/img/title3@2x.png" alt="" />
        </div>
        <div class="zhexian" style="background: #ffffff"></div>
      </div>
      <div
        class="center"
        style="padding-top: 50px; display: flex; justify-content: space-between"
      >
        <div
          class="equipment_box"
          v-for="(item, index) in equipmentlist"
          :key="index"
          @mouseover="equipmentOver(index)"
          @mouseleave="equipmentLeave"
        >
          <div
            :class="{
              equipment_box_imgs: equipmentnum == index,
              equipment_box_img: true,
            }"
          >
            <img
              :src="item.url"
              alt=""
              :class="{
                equipment_box_img_imgs: equipmentnum == index,
                equipment_box_img_img: true,
              }"
            />
          </div>

          <p :class="{ equipmentps: equipmentnum == index, equipmentp: true }">
            {{ item.p }}
          </p>
          <i
            :class="{ eequipmenti: equipmentnum == index, eequipmentis: true }"
            >{{ item.i }}</i
          >
        </div>
      </div>
    </div>

    <div class="wholesale_programme_title" style="padding-top: 71px">
      <div class="wholesale_programme_title_text" style="width: 120px">
        应用场景
        <img src="../../assets/img/title3@2x.png" alt="" />
      </div>
      <div class="zhexian"></div>
    </div>
    <div
      class="center"
      style="padding-top: 50px; display: flex; justify-content: space-between"
    >
      <div
        class="application_box"
        v-for="(item, index) in applicationlist"
        :key="index"
        @mouseover="eapplicationOver(index)"
        @mouseleave="applicationLeave"
      >
        <!-- @mouseover="eapplicationOver(index)"
        @mouseleave="applicationLeave" -->
        <div
          style="
            width: 384px;
            height: 230px;
            overflow: hidden;
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
          "
        >
          <img :src="item.url" alt="" />
        </div>
        <p>{{ item.p }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      paytext: [
        {
          p: "前端结算节约人力",
          i1: "窗口结算模式需要大量人力投入，资金清算需要核对大量凭证，",
          i2: "同时可以很大程度提升交易效率。",
        },
        {
          p: "经营模式改革",
          i1: "窗口结算模式需要大量人力投入，资金清算需要核对大量凭证，",
          i2: "同时可以很大程度提升交易效率。",
        },
        {
          p: "提供增值服务",
          i1: "T+n清算方案，提供更多的资金沉淀。",
          i2: "电子钱包，可以提供包括赊账、贷款、理财等金融服务。",
        },
        {
          p: "平台化结算系统",
          i1: "符合信息化安全等级保护要求，保障结算系统安全。",
          i2: "多支付通道冗余，保障支付质量。",
        },
      ],
      paymentmethods: [
        {
          url: require("../../assets/img/zf_1@2x.png"),
          p: "付款码支付",
          i: "微信、支付宝、银联付款码",
        },
        {
          url: require("../../assets/img/zf_2@2x.png"),
          p: "扫码支付",
          i: "微信、支付宝、银联付款码",
        },
        {
          url: require("../../assets/img/zf_3@2x.png"),
          p: "银行卡支付",
          i: "传统银行卡",
        },
        {
          url: require("../../assets/img/zf_4@2x.png"),
          p: "会员钱包",
          i: "会员充值钱包",
        },
        {
          url: require("../../assets/img/zf_5@2x.png"),
          p: "赊销支付",
          i: "信用赊账支付",
        },
      ],
      equipmentlist: [
        {
          url: require("../../assets/img/sb_1@2x.png"),
          p: "语音播报音响",
          i: "微信、支付宝、银联二维码",
        },
        {
          url: require("../../assets/img/sb_2@2x.png"),
          p: "防水收款码",
          i: "微信、支付宝、银联二维码",
        },
        {
          url: require("../../assets/img/sb_3@2x.png"),
          p: "智能POS机",
          i: "传统银行卡",
        },
        {
          url: require("../../assets/img/sb_4@2x.png"),
          p: "收银秤",
          i: "称重收银一体秤",
        },
      ],
      applicationlist: [
        {
          url: require("../../assets/img/cj_1@2x.png"),
          p: "农产品批发市场",
        },
        {
          url: require("../../assets/img/cj_2@2x.png"),
          p: "水产海鲜交易市场",
        },
        {
          url: require("../../assets/img/cj_3@2x.png"),
          p: "国际进出口食品市场",
        },
      ],

      pnumber: false,
      pnumbers: "-1",
      equipmentnum: "-1",
      eapplicationnum: "-1",
    };
  },

  created() {
    this.$store.commit("solutions", -1);
    this.$store.commit("solutions", 1);
  },
  methods: {
    eapplicationOver(index) {
      this.eapplicationnum = index;
    },
    applicationLeave() {
      this.eapplicationnum = "-1";
    },
    mouseOver(index) {
      this.pnumber = true;
      this.pnumbers = index;
    },
    mouseLeave() {
      this.pnumber = false;
      this.pnumbers = "-1";
    },
    equipmentOver(index) {
      this.equipmentnum = index;
    },
    equipmentLeave() {
      this.equipmentnum = "-1";
    },
  },
};
</script>

<style scoped>
.center {
  width: 1200px;
  margin: 0 auto;
}
.wholesale_programme_title {
  width: 1200px;
  margin: 0 auto;
}
.wholesale_programme_title_text {
  text-align: center;
  margin: 0 auto;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.wholesale_programme_title_text img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -15px;
}
.zhexian {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 16px;
}
.zhexian_text {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.pay_top_box:nth-child(1) {
  margin-top: 40px;
  width: 500px;
  height: 144px;
  background: linear-gradient(180deg, #98c7fb 0%, #5f96f5 100%);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  position: relative;
  margin-left: 50px;
}
.pay_top_box:nth-child(1) .top_box_y {
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 100%;
  background-image: linear-gradient(
    360deg,
    rgba(229, 229, 229, 1),
    rgba(244, 244, 244, 1)
  );
  position: absolute;
  top: 22px;
  left: -50px;
}

.pay_top_box:nth-child(1) .box_y_n {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background: linear-gradient(180deg, #98c7fb 0%, #5f96f5 100%);
  text-align: center;
  line-height: 80px;
  font-size: 44px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}

.pay_top_box:nth-child(1) .top_box_text {
  margin-left: 74px;
  padding-top: 32px;
}
.pay_top_box:nth-child(1) .top_box_text p {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px;
}
.pay_top_box:nth-child(1) .top_box_text i {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: block;
}
/* 第二个子元素 */
.pay_top_box:nth-child(2) {
  margin-top: 40px;
  width: 500px;
  height: 144px;
  background: linear-gradient(360deg, #4e75ff 0%, #9fafff 100%);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  position: relative;
  margin-left: 50px;
}
.pay_top_box:nth-child(2) .top_box_y {
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 100%;
  background-image: linear-gradient(
    360deg,
    rgba(229, 229, 229, 1),
    rgba(244, 244, 244, 1)
  );

  position: absolute;
  top: 22px;
  left: -50px;
}

.pay_top_box:nth-child(2) .box_y_n {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background: linear-gradient(360deg, #4e75ff 0%, #9fafff 100%);
  text-align: center;
  line-height: 80px;
  font-size: 44px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}

.pay_top_box:nth-child(2) .top_box_text {
  margin-left: 74px;
  padding-top: 32px;
}
.pay_top_box:nth-child(2) .top_box_text p {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px;
}
.pay_top_box:nth-child(2) .top_box_text i {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: block;
}
/* 第三个子元素 */
.pay_top_box:nth-child(3) {
  margin-top: 40px;
  width: 500px;
  height: 144px;
  background: linear-gradient(180deg, #3691e4 0%, #1958c4 100%);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  position: relative;
  margin-left: 50px;
}
.pay_top_box:nth-child(3) .top_box_y {
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 100%;
  background-image: linear-gradient(
    360deg,
    rgba(229, 229, 229, 1),
    rgba(244, 244, 244, 1)
  );
  position: absolute;
  top: 22px;
  left: -50px;
}

.pay_top_box:nth-child(3) .box_y_n {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background: linear-gradient(180deg, #3691e4 0%, #1958c4 100%);
  text-align: center;
  line-height: 80px;
  font-size: 44px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}

.pay_top_box:nth-child(3) .top_box_text {
  margin-left: 74px;
  padding-top: 32px;
}
.pay_top_box:nth-child(3) .top_box_text p {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px;
}
.pay_top_box:nth-child(3) .top_box_text i {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: block;
}
/* 第四个子元素 */
.pay_top_box:nth-child(4) {
  margin-top: 40px;
  width: 500px;
  height: 144px;
  background: linear-gradient(180deg, #3856e6 0%, #2c35a5 100%);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  position: relative;
  margin-left: 50px;
}
.pay_top_box:nth-child(4) .top_box_y {
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 100%;
  background-image: linear-gradient(
    360deg,
    rgba(229, 229, 229, 1),
    rgba(244, 244, 244, 1)
  );
  position: absolute;
  top: 22px;
  left: -50px;
}

.pay_top_box:nth-child(4) .box_y_n {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background: linear-gradient(180deg, #3878e6 0%, #1b329a 100%);
  text-align: center;
  line-height: 80px;
  font-size: 44px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}

.pay_top_box:nth-child(4) .top_box_text {
  margin-left: 74px;
  padding-top: 32px;
}
.pay_top_box:nth-child(4) .top_box_text p {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px;
}
.pay_top_box:nth-child(4) .top_box_text i {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: block;
}

.paymentmethod {
  width: 220px;
  height: 180px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding-top: 40px;
}
.paymentmethod1 {
  width: 220px;
  height: 202px;
  background: #e9f4ff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding-top: 18px;
}
.paymentmethod_box {
  padding-left: 65px;
}
.paymentmethod_box img {
  width: 90px;
  height: 90px;
}
.paymentmethodp {
  margin-top: 30px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  text-align: center;
}
.paymentmethodis {
  display: none;
}
.paymentmethodi {
  margin-top: 12px;
  margin-bottom: 18px;
  display: block;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  text-align: center;
}

.equipment {
  width: 100%;
  height: 560px;
  background-image: url("../../assets/img/zfsb_back@2x.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.equipment_box {
  width: 282px;
  height: 340px;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
}
.equipment_box_img {
  width: 282px;
  height: 282px;
  position: relative;
}
.equipment_box_imgs {
  width: 282px;
  height: 202px;
  position: relative;
}
.equipment_box_img_img {
  width: 282px;
  height: 282px;
  position: absolute;
}
.equipment_box_img_imgs {
  width: 282px;
  height: 282px;
  position: absolute;
  top: -80px;
}
.equipmentps {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1958c4 !important;
  line-height: 28px;
  text-align: center;
}
.equipmentp {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
  text-align: center;
}
.eequipmentis {
  display: none;
}
.eequipmenti {
  display: block;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  text-align: center;
  margin-top: 12px;
}
.application_box {
  width: 384px;
  height: 298px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);

  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  margin-bottom: 50px;
  color: #333333;
}
.application_box img {
  width: 384px;
  height: 230px;
  transition-duration: 1s;
}
.application_box img:hover {
  transform: scale(1.3);
  /* 实现伸缩缓动 配合 transition-duration: 1s;使用*/
  transition-timing-function: linear;
}
.application_box p {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  margin-top: 16px;
}
.application_box:hover {
  color: #1958c4;
  cursor: pointer;
}
</style>